import { defineStore } from 'pinia'
import { useStore } from '@/stores/index'

export const useMyStoreStore = defineStore('myStore', {

state: () => ({
  stores: [],
  nearStores: [],
  myStores: [],
  activeMyStoreId: null,
  utmSource: null,
  splashBgImage: '',
  maxlen: 3,
}),

getters: {
  isRegistered: (state) => {
    return state.myStores.length > 0
  },
  prefectures: (state) => {
    if (0 in state.stores) {
      return state.stores.map(item => {
        return item.prefectureName
      })
    } else {
      return []
    }
  },
  myStoreOrderedArray: (state) => {
    let storeArray = []
    storeArray = storeArray.concat(state.myStores)
    if (storeArray.length) {
      if (storeArray[0].shopId !== state.activeMyStoreId) {
        storeArray.some(
          item =>
            item.shopId === state.activeMyStoreId &&
            storeArray.splice(storeArray.indexOf(item), 1) &&
            storeArray.unshift(item)
        )
      }
    }
    return storeArray
  },
},

// export const mutations = {
//   setStores(state, stores) {
//     state.stores = stores
//   },
//   setNearStores(state, stores) {
//     state.nearStores = stores
//   },
//   clearLocationSearchResults(state) {
//     state.nearStores = []
//   },
//   setMyStores(state, myStores) {
//     state.myStores = myStores
//   },
//   setActiveMyStoreId(state, id) {
//     state.activeMyStoreId = id
//   },
//   setUtmSource(state, value) {
//     state.utmSource = value
//   },
//   setIsSavingMyStore(state, value) {
//     state.isSavingMyStore = value
//   },
//   setSplashBgImage(state, image) {
//     state.splashBgImage = image
//   },
// },

actions: {
  async fetchStores() {
    const rootStore = useStore()
    const runtimeConfig = useRuntimeConfig()
    await POST('get_chainshop_list', {
      body: {
        clientKey: runtimeConfig.public.clientKey,
        mediaId: rootStore.mediaId,
        chainId: rootStore.chainId,
        accessToken: rootStore.accessToken,
        impressionKey: rootStore.user.impressionKey,
        reqTime: UNIXTIMESTAMP(),
      },
    })
      .then(res => {
        const stores = res.data.prefectures
        this.stores = stores
      })
      .catch(err => {
        const status = err.status
        const error = err.data.error.errorCode
        // アクセストークンが期限切れ
        if (status === 401 && error === '10001') {
          rootStore.refreshTokens()
        }
      })
  },
  async saveMyStore({ shops }) {
    const rootStore = useStore()
    const runtimeConfig = useRuntimeConfig()
    const updateActiveMyStoreId = (myStores, activeMyStoreId) => {
      let exist = false
      for (let i = 0; i < myStores.length; i++) {
        if (exist) break
        if (
          myStores[i].shopCode === activeMyStoreId
        )
          exist = true
      }
      if (myStores.length === 0) {
        this.activeMyStoreId = null
      } else if (!exist) {
        this.activeMyStoreId = myStores[0].shopCode
      }
    }
    if (!rootStore.accessToken) {
      try {
        // // LocalStorageに店舗IDと店舗名を保存処理
        const localStrageValue = JSON.stringify(
          shops.map(shop => ({
            shopName: shop.store,
            shopCode: shop.shopCode,
            shopId: shop.value,
            shopUrl: shop.shopUrl,
            address: shop.address,
          }))
        )
        window.localStorage.setItem('myStores', localStrageValue)
        updateActiveMyStoreId(
          JSON.parse(localStrageValue),
          this.activeMyStoreId
        )
        return Promise.resolve(true)
      } catch (error) {
        rootStore.$patch({ alertMessage: {
          title: '登録できませんでした',
          body: 'お気に入り店舗の登録に失敗いたしました',
        }})
        return Promise.reject(new Error(''))
      }
    }
    this.isSavingMyStore = true 

    const shopIds = shops.map(item => item.value)

    await POST('set_myshop', {
      method: 'post',
      body: {
        clientKey: runtimeConfig.public.clientKey,
        mediaId: rootStore.mediaId,
        chainId: rootStore.chainId,
        shopId: shopIds,
        accessToken: rootStore.accessToken,
        impressionKey: rootStore.user.impressionKey,
        reqTime: UNIXTIMESTAMP(),
      },
    })
      .then(res => {
        const myStores = res.data.shops
        this.myStores = myStores
        updateActiveMyStoreId(myStores, state.activeMyStoreId)
      })
      .catch(err => {
        const status = err.status
        const error = err.data.error.errorCode
        // アクセストークンが期限切れ
        if (status === 401 && error === '10001') {
          rootStore.refreshTokens()
        } else {
          const res = err.data.error
          rootStore.$patch({ alertMessage: {
            title: res.errorMessage,
            body: res.errorMessageDetail
          }})
        }
      })
      .finally(() => {
        this.isSavingMyStore = false
      })
  },
  async fetchMyStores() {
    const rootStore = useStore()
    const runtimeConfig = useRuntimeConfig()
    if (!rootStore.accessToken) {
      const result = JSON.parse(window.localStorage.getItem('myStores')) || []
      this.myStores = result
      if (!this.activeMyStoreId && result[0]) {
        this.activeMyStoreId = result[0].shopId
      }
      return
    }
    await POST('get_myshop', {
      body: {
        clientKey: runtimeConfig.public.clientKey,
        mediaId: rootStore.mediaId,
        chainId: rootStore.chainId,
        accessToken: rootStore.accessToken,
        impressionKey: rootStore.user.impressionKey,
        reqTime: UNIXTIMESTAMP(),
      },
    })
      .then(res => {
        const splashBgImage = res.data.flyerSample
        this.splashBgImage = splashBgImage
        const myStores = res.data.shops
        this.myStores = myStores
        if (myStores.length === 0) {
          return
        }
        if (!this.activeMyStoreId && myStores[0]) {
          this.activeMyStoreId = myStores[0].shopId
        }
      })
      .catch(err => {
        const status = err.status
        const error = err.data.error.errorCode
        // アクセストークンが期限切れ
        if (status === 401 && error === '10001') {
          rootStore.refreshTokens()
        } else {
          return Promise.reject(err)
        }
      })
  },
  async searchStoresFromCurrentLocation({ lat, lng }) {
    const rootStore = useStore()
    const runtimeConfig = useRuntimeConfig()
    await POST('search_chainshop', {
      body: {
        clientKey: runtimeConfig.public.clientKey,
        mediaId: rootStore.mediaId,
        chainId: rootStore.chainId,
        accessToken: rootStore.accessToken,
        impressionKey: rootStore.user.impressionKey,
        lat,
        lng,
        // TODO: 検索範囲は20kmでよいか？
        range: 20,
        // TODO: 最大取得件数は10件でよいか？
        count: 10,
        reqTime: UNIXTIMESTAMP(),
      },
    })
      .then(res => {
        const stores = res.data.shops
        this.nearStores = stores
      })
      .catch(err => {
        const status = err.status
        const error = err.data.error.errorCode
        // アクセストークンが期限切れ
        if (status === 401 && error === '10001') {
          rootStore.refreshTokens()
        } else {
          const res = err.data.error
          rootStore.$patch({ alertMessage: {
            title: res.errorMessage,
            body: res.errorMessageDetail
          }})      
        }
      })
    },
  }
})